import script from "./groupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./groupList.vue?vue&type=script&setup=true&lang=ts"

import "./groupList.vue?vue&type=style&index=0&id=2f7b6caa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7b6caa"]])

export default __exports__